import { ReactNode, useEffect } from 'react'

import { PageTemplateContent } from 'app/common/templates-next/page-template'

import PlainButton from 'app/common/ui-next/plain-button'
import { useFoodSuppliers } from 'app/dataProviders/cafeteria/compensation/foodSuppliers/hooks'
import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainLabel from 'app/common/ui-next/plain-label'
import { PlainColumns } from 'app/common/ui/PlainGrid'
import PlainLink from 'app/common/ui-next/plain-link'
import classNames from 'classnames/bind'
import { SupplierSelectorLoading } from './SupplierSelectorLoading'
import styles from './SupplierSelector.scss'


const cx = classNames.bind(styles)


type Props = {
  studentID: string
  supplierID: string | null
  render?: boolean
  onChangeSupplier: (supplierID: string) => void
  returnLink: string
  children?: ReactNode
}

export const SupplierSelector = ({
  studentID,
  supplierID,
  render = true,
  onChangeSupplier,
  returnLink,
  children,
}: Props) => {
  const { foodSuppliers, loading } = useFoodSuppliers({ studentID })

  useEffect(() => {
    if (!render && foodSuppliers.length) {
      onChangeSupplier(foodSuppliers[0].ID)
    }
  }, [foodSuppliers, onChangeSupplier, render])

  if (!render && children) {
    return children
  }

  if (loading) {
    return <SupplierSelectorLoading />
  }

  const onSelectFoodSupplier = (supplierId: string) => {
    onChangeSupplier(supplierId)
  }


  const supplierWithoutSelected = foodSuppliers.filter(supplier => supplier.ID !== supplierID)
  const currentSupplierInfo = foodSuppliers.find(supplier => supplier.ID === supplierID)


  return (
    <PageTemplateContent spaceBetweenVertical>
      <ControlsBar middle>
        <PlainLabel skipUpperSpace id="food_supplier" className={styles.label}>
          {'Выберите поставщика питания:'}
        </PlainLabel>
      </ControlsBar>
      <PlainColumns className={cx(styles.row, styles.supplierInfo)}>
        <PlainLabel id="curSupplier" className={styles.label}>
          {'Текущий поставщик: '}
        </PlainLabel>
        {currentSupplierInfo
          && <PlainLink
            to={returnLink}
            className={styles.button}
          >
            {currentSupplierInfo.title}
          </PlainLink>}
      </PlainColumns>
      <PlainLabel id="otherSupplier" className={styles.label}>
        {'Другие поставщики питания: '}
      </PlainLabel>
      <ControlsBar className={styles.item} middle>
        {supplierWithoutSelected.map((supplier) => {
          return (
            <PlainButton
              key={supplier.ID}
              onClick={() => onSelectFoodSupplier(supplier.ID)}
              outline={supplier.ID === supplierID}
            >
              {supplier.title}
            </PlainButton>
          )
        })}
      </ControlsBar>
    </PageTemplateContent>
  )
}
